// extracted by mini-css-extract-plugin
export default {"chart":"styles_chart__rLk77","chart__content":"styles_chart__content__3Nqsa"};